import { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import { matrimonyAPI, decorAPI, cateringAPI } from '../utils/api';

export default function Contact() {
  const [contacts, setContacts] = useState({ matrimony: null, decor: null, catering: null });
  const [form, setForm] = useState({ name: '', phone: '', email: '', subject: '', message: '' });
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('matrimony');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    Promise.all([
      matrimonyAPI.getAbout().then(d => ({ matrimony: { address: d.address, phone_primary: d.phone_primary, phone_secondary: d.phone_secondary, email_primary: d.email_primary, office_hours: d.office_hours } })),
      decorAPI.getContact().then(d => ({ decor: { address: d.address, phone_primary: d.phone_primary, phone_secondary: d.phone_secondary, email_primary: d.email_primary, office_hours: d.office_hours } })),
      cateringAPI.getContact().then(d => ({ catering: { address: d.address, phone_primary: d.phone_primary, phone_secondary: d.phone_secondary, email_primary: d.email_primary, office_hours: d.office_hours } }))
    ]).then(results => {
      const merged = { ...results[0], ...results[1], ...results[2] };
      setContacts(merged);
    }).catch(() => {});
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setMsg(null);
    try {
      const data = { ...form };
      let result;
      if (activeTab === 'matrimony') {
        result = await matrimonyAPI.sendMessage(data);
      } else if (activeTab === 'decor') {
        result = await decorAPI.sendMessage(data);
      } else {
        result = await cateringAPI.sendMessage(data);
      }
      setMsg({ ok: true, text: result.message || 'Message sent! We will reply soon.' });
      setForm({ name: '', phone: '', email: '', subject: '', message: '' });
    } catch (e) {
      setMsg({ ok: false, text: 'Could not send. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  const currentContact = contacts[activeTab] || {};
  const titles = {
    matrimony: { emoji: '💒', title: 'Marriage Consultation', subtitle: 'Vivah Matrimony' },
    decor: { emoji: '🌸', title: 'Wedding Decor', subtitle: 'Vivah Decor' },
    catering: { emoji: '🍽️', title: 'Wedding Catering', subtitle: 'Vivah Catering' }
  };
  const colors = {
    matrimony: { bg: 'var(--rose-l)', icon: 'var(--rose)', btn: 'btn-rose' },
    decor: { bg: 'var(--gold-l)', icon: 'var(--gold)', btn: 'btn-gold' },
    catering: { bg: 'var(--spice-l)', icon: 'var(--spice)', btn: 'btn-spice' }
  };

  return (
    <div className="pi">
      <Navbar module={activeTab === 'matrimony' ? 'consult' : activeTab} />
      <div className="sh">
        <span className="ey ey-s">✦ Contact Us</span>
        <h1>Get in Touch with <em>Vivah</em></h1>
      </div>
      <div className="sec" style={{ maxWidth: 'clamp(320px, 100%, 1100px)' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'clamp(0.4rem, 1.5vw, 0.65rem)', marginBottom: 'clamp(1rem, 3vw, 1.8rem)', justifyContent: 'center' }}>
          {['matrimony', 'decor', 'catering'].map(t => (
            <button key={t} onClick={() => { setActiveTab(t); setMsg(null); }} style={{ padding: 'clamp(0.3rem, 1vw, 0.5rem) clamp(0.8rem, 2vw, 1.2rem)', borderRadius: '100px', border: '1px solid', fontFamily: 'var(--sans)', fontWeight: 500, fontSize: 'clamp(0.75rem, 1.5vw, 0.85rem)', cursor: 'pointer', transition: 'var(--ease)', borderColor: activeTab === t ? colors[t].icon : 'var(--cream-d)', background: activeTab === t ? colors[t].icon : '#fff', color: activeTab === t ? '#fff' : 'var(--mid)' }}>
              {titles[t].emoji} {titles[t].title}
            </button>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'clamp(280px, 100%, 1fr) clamp(280px, 100%, 1.2fr)', gap: 'clamp(1.2rem, 3vw, 2rem)' }}>
          <div>
            <div className="card" style={{ marginBottom: 'clamp(0.8rem, 2vw, 1.2rem)' }}>
              <h3 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(1.1rem, 2.5vw, 1.3rem)', fontWeight: 600, marginBottom: 'clamp(0.8rem, 2vw, 1.2rem)' }}>{titles[activeTab].subtitle}</h3>
              {[
                ['📍', 'Address', currentContact.address || 'Nepalgunj, Banke, Lumbini Province'],
                ['📞', 'Phone', [currentContact.phone_primary, currentContact.phone_secondary].filter(Boolean).join('\n') || '+977 981-2345678'],
                ['✉️', 'Email', currentContact.email_primary || 'contact@vivahnepal.com'],
                ['🕐', 'Hours', currentContact.office_hours || 'Sun–Fri: 8am–7pm']
              ].map(([icon, lbl, val]) => (
                <div key={lbl} style={{ display: 'flex', gap: 'clamp(0.5rem, 1.5vw, 0.85rem)', marginBottom: 'clamp(0.8rem, 2vw, 1.1rem)', paddingBottom: 'clamp(0.8rem, 2vw, 1.1rem)', borderBottom: '1px solid var(--cream-d)' }}>
                  <div style={{ width: 'clamp(28px, 6vw, 34px)', height: 'clamp(28px, 6vw, 34px)', borderRadius: 'clamp(7px, 1.5vw, 9px)', background: colors[activeTab].bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'clamp(0.8rem, 1.8vw, 0.95rem)', flexShrink: 0 }}>{icon}</div>
                  <div>
                    <div style={{ fontSize: 'clamp(0.6rem, 1.3vw, 0.72rem)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '.08em', color: 'var(--muted)', marginBottom: 'clamp(0.1rem, 0.5vw, 0.15rem)' }}>{lbl}</div>
                    <div style={{ fontSize: 'clamp(0.76rem, 1.8vw, 0.88rem)', color: 'var(--deep)', lineHeight: 1.55, whiteSpace: 'pre-line' }}>{val}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="card">
              <h4 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(0.95rem, 2.5vw, 1.1rem)', fontWeight: 600, marginBottom: 'clamp(0.6rem, 1.5vw, 0.9rem)' }}>Send a Message</h4>
              {msg && <div className={`al ${msg.ok ? 'al-ok' : 'al-er'}`}>{msg.text}</div>}
              <form onSubmit={handleSubmit}>
                <div className="fg"><label>Name</label><input value={form.name} onChange={(e) => handleChange({ target: { name: 'name', value: e.target.value } })} placeholder="Your name" required /></div>
                <div className="fg"><label>Phone</label><input value={form.phone} onChange={(e) => handleChange({ target: { name: 'phone', value: e.target.value } })} placeholder="+977-98..." required /></div>
                <div className="fg"><label>Email</label><input type="email" value={form.email} onChange={(e) => handleChange({ target: { name: 'email', value: e.target.value } })} placeholder="you@email.com" /></div>
                <div className="fg"><label>Subject</label><input value={form.subject} onChange={(e) => handleChange({ target: { name: 'subject', value: e.target.value } })} placeholder="Your subject" /></div>
                <div className="fg"><label>Message</label><textarea value={form.message} onChange={(e) => handleChange({ target: { name: 'message', value: e.target.value } })} placeholder="Your message..." required /></div>
                <button className={`btn ${colors[activeTab].btn} btn-blk`} type="submit" disabled={loading}>{loading ? 'Sending…' : 'Send Message'}</button>
              </form>
            </div>
          </div>
          <div style={{ borderRadius: 'var(--rlg)', overflow: 'hidden', border: '1px solid var(--cream-d)', minHeight: 'clamp(300px, 50vw, 440px)', background: 'linear-gradient(135deg,#EDE5D8,#D4C4B0)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 'clamp(0.6rem, 1.5vw, 1rem)', padding: 'clamp(1.2rem, 3vw, 2rem)', textAlign: 'center' }}>
            <div style={{ fontSize: 'clamp(2rem, 7vw, 3rem)' }}>{titles[activeTab].emoji}</div>
            <div style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', color: 'var(--mid)' }}>{titles[activeTab].subtitle}</div>
            <div style={{ fontSize: 'clamp(0.72rem, 1.8vw, 0.82rem)', color: 'var(--muted)', marginBottom: 'clamp(0.6rem, 1.5vw, 1rem)' }}>Lumbini Province, Nepal</div>
            <a href={`tel:${currentContact.phone_primary || '+977-981-2345678'}`} className={`btn ${colors[activeTab].btn} btn-sm`} style={{ marginTop: 'clamp(0.35rem, 1vw, 0.5rem)' }}>Call Us ↗</a>
          </div>
        </div>
      </div>
      <style>{`@media(max-width:768px){div[style*="grid-template-columns: clamp(280px"]{grid-template-columns:1fr!important}}`}</style>
    </div>
  );
}
